import React, { useState, useEffect,useContext } from "react";
import Swal from "sweetalert2";
import axios from 'axios';

import { AppContext } from "../../../services/AppContext";
import AuthContext from '../../../context/auth-context';

import { MdEdit, MdErrorOutline, MdSave, MdCheck } from "react-icons/md";

import useInput from '../../../hooks/useInput';
import useFileInput from '../../../hooks/useFileInput';
import useGetPaises from '../../../hooks/useGetPaises';
import useGetEstadoCivil from '../../../hooks/useGetEstadoCivil';
import useGetTipoIdentificacion from '../../../hooks/useGetTipoIdentificacion';

import useInputDatePicker from "../../../hooks/useInputDatePicker";


import Card from '../../../components/UI/Card';
import useGetIdioma from "../../../hooks/useGetIdiomas";
import useGetDatosPersonales from "../../../hooks/useGetDatosPersonales";

//import DatePicker from 'rsuite/DatePicker';
import DatePicker from "react-datepicker";
//import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import 'react-datepicker/dist/react-datepicker.css';

import "./styleforarrow.css";

import moment from 'moment';

const DatosPersonales = (props) => {
    const { setAppValues } = useContext(AppContext);
    const authContext = useContext(AuthContext);

    const [error, setError] = useState(false);
    
    const [block, setBlock] = useState(false);
    const handleEditar = () => {
        setBlock(!block);
    }
    
    function cuiIsValid(cui) {
        if(isNaN(cui)) {
            return false;
        }
        var cuiRegExp = /^[0-9]{4}\s?[0-9]{5}\s?[0-9]{4}$/;
        if(!cuiRegExp.test(cui)) {
            return false;
        }
        cui = cui.replace(/\s/, '');
        var depto = parseInt(cui.substring(9, 11), 10);
        var muni = parseInt(cui.substring(11, 13));
        var numero = cui.substring(0, 8);
        var verificador = parseInt(cui.substring(8, 9));
        var munisPorDepto = [17, 8, 16, 16, 13, 14, 19,  8, 24, 21,  9, 
                            30, 32, 21,  8, 17, 14,  5, 11, 11,  7, 17 ];
        if (depto === 0 || muni === 0) {
            return false;
        }
        if (depto > munisPorDepto.length) {
            return false;
        }
        if (muni > munisPorDepto[depto - 1]) {
            return false;
        }
        var total = 0;
        for (var i = 0; i < numero.length; i++) {
            total += numero[i] * (i + 2);
        }
        var modulo = (total % 11);
        return (modulo === verificador);
    }

    const [isUpdate, setIsUpdate] = useState(false);
    
    const datosPersonales = useGetDatosPersonales(authContext.token);
    
    useEffect(() => {
        if(datosPersonales.LOADING){
            Swal.fire({
                title: `Loading...
                    <div class="spinner-border text-primary mt-4" role="status" />
                `,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            return;
        }
        Swal.close();

        if(datosPersonales.STATUS && datosPersonales.STATUS === "SUCCESS"){
            setError(false);

        } else if(datosPersonales.STATUS && datosPersonales.STATUS === "ERROR"){
            setError(true);

            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: datosPersonales.ERROR.MESSAGE,
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });

        } else {
            setError(true);
            
            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: 'Ocurrió un problema, intentelo más tarde',
                showConfirmButton: false,
            });
        }
    }, [datosPersonales]);

    const nacionalidades = useGetPaises();
    const estados = useGetEstadoCivil();
    const tipo_identifiacacion = useGetTipoIdentificacion();

    //INPUT PRIMER NOMBRE
    const primerNombreValidacion = value => value.trim() !== "";
    const {
        value: primerNombre,
        isValid: primerNombreIsValid,
        isTouched: primerNombreIsTouched,
        userChange: primerNombreUserChange,
        divInput: divPrimerNombre,
        valueChangeHandler: primerNombreChangeHanlder,
        inputBlurHandler: primerNombreBlurHandler,
        scrollToDiv: scrollToDivPrimerNombre,
        setInputValue: setPrimerNombreValue
    } = useInput(primerNombreValidacion);

    useEffect(() => {
        if(!!datosPersonales.nombre1 && !primerNombreUserChange){
            setPrimerNombreValue(datosPersonales.nombre1);
        } 
    }, [datosPersonales.nombre1, primerNombreUserChange, setPrimerNombreValue]);

    //INPUT SEGUNDO NOMBRE
    /*const segundoNombreValidacion = value => !!value && value instanceof String && value.trim() !== "";
    const {
        value: segundoNombre,
        userChange: segundoNombreUserChange,
        divInput: divSegundoNombre,
        valueChangeHandler: segundoNombreChangeHanlder,
        inputBlurHandler: segundoNombreBlurHandler,
        setInputValue: setSegundoNombreValue
    } = useInput(segundoNombreValidacion);*/


        //INPUT SEGUNDO NOMBRE
        const segundoNombreValidacion = value => true;
    const {
        value: segundoNombre,
        userChange: segundoNombreUserChange,
        divInput: divSegundoNombre,
        valueChangeHandler: segundoNombreChangeHanlder,
        isValid: segundoNombreIsValid,
        isTouched: segundoNombreIsTouched,
        inputBlurHandler: segundoNombreBlurHandler,
        setInputValue: setSegundoNombreValue,
        scrollToDiv: scrollToDivSegundoNombre
    } = useInput(segundoNombreValidacion);

    useEffect(() => {
        if(!!datosPersonales.nombre2 && !segundoNombreUserChange){
            setSegundoNombreValue(datosPersonales.nombre2);
        }
    }, [datosPersonales.nombre2, segundoNombreUserChange, setSegundoNombreValue]);

    //INPUT PRIMER APELLIDO
    const primerApellidoValidacion = value => value.trim() !== "";
    const {
        value: primerApellido,
        isValid: primerApellidoIsValid,
        isTouched: primerApellidoIsTouched,
        userChange: primerApellidoUserChange,
        divInput: divPrimerApellido,
        valueChangeHandler: primerApellidoChangeHanlder,
        inputBlurHandler: primerApellidoBlurHandler,
        scrollToDiv: scrollToDivPrimerApellido,
        setInputValue: setPrimerApellidoValue
    } = useInput(primerApellidoValidacion);

    useEffect(() => {
        if(!!datosPersonales.apellido1 && !primerApellidoUserChange){
            setPrimerApellidoValue(datosPersonales.apellido1);
        }
    }, [datosPersonales.apellido1, primerApellidoUserChange, setPrimerApellidoValue]);

    //INPUT SEGUNDO APELLIDO
    const segundoApellidoValidacion = value => true;
    const {
        value: segundoApellido,
        isValid: segundoApellidoIsValid,
        isTouched: segundoApellidoIsTouched,
        userChange: segundoApellidoUserChange,
        divInput: divSegundoApellido,
        valueChangeHandler:segundoApellidoChangeHanlder,
        inputBlurHandler: segundoApellidoBlurHandler,
        scrollToDiv: scrollToDivSegundoApellido,
        setInputValue: setSegundoApellidoValue
    } = useInput(segundoApellidoValidacion);

    useEffect(() => {
        if(!!datosPersonales.apellido2 && !segundoApellidoUserChange){
            setSegundoApellidoValue(datosPersonales.apellido2);
        }
    }, [datosPersonales.apellido2, segundoApellidoUserChange, setSegundoApellidoValue]);

    //INPUT APELLIDO DE CASADA
    const apellidoCasadaValidacion = value => value.trim() !== "";
    const {
        value: apellidoCasada,
        isValid: apellidoCasadaIsValid,
        isTouched: apellidoCasadaIsTouched,
        userChange: apellidoCasadaUserChange,
        divInput: divApellidoCasada,
        valueChangeHandler:apellidoCasadaChangeHanlder,
        inputBlurHandler: apellidoCasadaBlurHandler,
        scrollToDiv: scrollToDivApellidoCasada,
        setInputValue: setApellidoCasadaValue
    } = useInput(apellidoCasadaValidacion);

    useEffect(() => {
        if(!!datosPersonales.apellido_casada && !apellidoCasadaUserChange){
            setApellidoCasadaValue(datosPersonales.apellido_casada);
        }
    }, [datosPersonales.apellido_casada, apellidoCasadaUserChange, setApellidoCasadaValue]);

    const fechaNaciemientoValidacion2 = value => value !== null; 
    const {
        value: fechaNaciemiento2,
        isValid: fechaNaciemientoIsValid2,
        isTouched: fechaNaciemientoIsTouched2,
        userChange: fechaNacimientoUserChange2,
        divInput: divFechaNaciemiento2,
        valueChangeHandler:fechaNaciemientoChangeHanlder2,
        inputBlurHandler: fechaNaciemientoBlurHandler2,
        scrollToDiv: scrollToDivFechaNaciemiento2,
        setInputValue: setFechaNacimientoValue2
    } = useInputDatePicker(fechaNaciemientoValidacion2);
    

    useEffect(() => {
        if(!!datosPersonales.fecha_nacimiento && !fechaNacimientoUserChange2){
            setFechaNacimientoValue2((datosPersonales.fecha_nacimiento));
        }
    }, [datosPersonales.fecha_nacimiento, fechaNacimientoUserChange2, setFechaNacimientoValue2]);
  
    //DATEPICKER FECHA INICIAL

    //const selected = moment(isoDateStr).toDate()

    //INPUT FECHA DE NACIMIENTO
    var date = new Date().toISOString().split("T")[0].split("-");
    /*const fechaNaciemientoValidacion = value => value.trim() !== "" && value < (date[0]-18 +'-'+date[1]+'-'+date[2]); 
    const {
        value: fechaNaciemiento,
        isValid: fechaNaciemientoIsValid,
        isTouched: fechaNaciemientoIsTouched,
        userChange: fechaNacimientoUserChange,
        divInput: divFechaNaciemiento,
        valueChangeHandler:fechaNaciemientoChangeHanlder,
        inputBlurHandler: fechaNaciemientoBlurHandler,
        scrollToDiv: scrollToDivFechaNaciemiento,
        setInputValue: setFechaNacimientoValue
    } = useInput(fechaNaciemientoValidacion);

    useEffect(() => {
        if(!!datosPersonales.fecha_nacimiento && !fechaNacimientoUserChange){
            setFechaNacimientoValue(datosPersonales.fecha_nacimiento);
        }
    }, [datosPersonales.fecha_nacimiento, fechaNacimientoUserChange, setFechaNacimientoValue]);*/

    //INPUT GENERO
    const generoValidacion = value => value.trim() !== "";
    const {
        value: genero,
        isValid: generoIsValid,
        isTouched: generoIsTouched,
        userChange: generoUserChange,
        divInput: divGenero,
        valueChangeHandler:generoChangeHanlder,
        inputBlurHandler: generoBlurHandler,
        scrollToDiv: scrollToDivGenero,
        setInputValue: setGeneroValue
    } = useInput(generoValidacion);

    useEffect(() => {
        if(!!datosPersonales.sexo && !generoUserChange){    
            setGeneroValue(datosPersonales.sexo);
        }
    }, [datosPersonales.sexo, generoUserChange, setGeneroValue]);

    //INPUT ESTADO CIVIL
    const estadoCivilValidacion = value => value.trim() !== "";
    const {
        value: estadoCivil,
        isValid: estadoCivilIsValid,
        isTouched: estadoCivilIsTouched,
        userChange: estadoCivilUserChange,
        divInput: divEstadoCivil,
        valueChangeHandler:estadoCivilChangeHanlder,
        inputBlurHandler: estadoCivilBlurHandler,
        scrollToDiv: scrollToDivEstadoCivil,
        setInputValue: setEstadoCivilValue
    } = useInput(estadoCivilValidacion);

    useEffect(() => {
        if(!!datosPersonales.estado_civil && !estadoCivilUserChange){    
            setEstadoCivilValue(datosPersonales.estado_civil);
        }
    }, [datosPersonales.estado_civil, estadoCivilUserChange, setEstadoCivilValue]);

    //INPUT NACIONALIDAD
    const nacionalidadValidacion = value => value.trim() !== "";
    const {
        value: nacionalidad,
        isValid: nacionalidadIsValid,
        isTouched: nacionalidadIsTouched,
        userChange: nacionalidadUserChange,
        divInput: divNacionalidad,
        valueChangeHandler:nacionalidadChangeHanlder,
        inputBlurHandler: nacionalidadBlurHandler,
        scrollToDiv: scrollToDivNacionalidad,
        setInputValue: setNacionalidadValue
    } = useInput(nacionalidadValidacion);

    useEffect(() => {
        if(!!datosPersonales.nacionalidad && !nacionalidadUserChange){    
            setNacionalidadValue(datosPersonales.nacionalidad);
        }
    }, [datosPersonales.nacionalidad, nacionalidadUserChange, setNacionalidadValue]);

    //INPUT TIPO DE DOCUMENTO
    const tipoDocumentoValidacion = value => value.trim() !== "";
    const {
        value: tipoDocumento,
        isValid: tipoDocumentoIsValid,
        isTouched: tipoDocumentoIsTouched,
        userChange: tipoDocumentoUserChange,
        divInput: divTipoDocumento,
        valueChangeHandler:tipoDocumentoChangeHanlder,
        inputBlurHandler: tipoDocumentoBlurHandler,
        scrollToDiv: scrollToDivTipoDocumento,
        setInputValue: setTipoDocValue
    } = useInput(tipoDocumentoValidacion);

    useEffect(() => {
        if(!!datosPersonales.tipo_identificacion && !tipoDocumentoUserChange){    
            setTipoDocValue(datosPersonales.tipo_identificacion);
        }
    }, [datosPersonales.tipo_identificacion, tipoDocumentoUserChange, setTipoDocValue]);

    //INPUT NUMERO DE DPI
    const dpiValidacion = value => value.trim() !== "" && cuiIsValid(value);
    const {
        value: dpi,
        isValid: dpiIsValid,
        isTouched: dpiIsTouched,
        userChange: dpiUserChange,
        divInput: divDpi,
        valueChangeHandler:dpiChangeHanlder,
        inputBlurHandler: dpiBlurHandler,
        scrollToDiv: scrollToDivDpi,
        setInputValue: setDpiValue
    } = useInput(dpiValidacion);

    useEffect(() => {
        if(!!datosPersonales.numero_dpi && !dpiUserChange){
            setDpiValue(datosPersonales.numero_dpi);
        }
    }, [datosPersonales.numero_dpi, dpiUserChange, setDpiValue]);

    //Input número de identificación.

    const numeroIdValidacion = value => value.trim() !== "" ;
    const {
        value: numeroId,
        isValid: numeroIdIsValid,
        isTouched: numeroIdIsTouched,
        userChange: numeroIdUserChange,
        divInput: divNumeroId,
        valueChangeHandler:numeroIdChangeHanlder,
        inputBlurHandler: numeroIdBlurHandler,
        scrollToDiv: scrollToDivNumeroId,
        setInputValue: setNumeroIdValue
    } = useInput(numeroIdValidacion);

    useEffect(() => {
        if(!!datosPersonales.numero_dpi && !numeroIdUserChange){
            setNumeroIdValue(datosPersonales.numero_dpi);
        }
    }, [datosPersonales.numero_dpi, numeroIdUserChange, setNumeroIdValue]);



    

    //INPUT ARCHIVO DE IDENTIFICACION PERSONAL
    const [nombreIdentificacionFile, setNombreIdentificacionFile] = useState("");
    const {
        value: identificacionFile,
        fileName: identificacionFileName,
        isValid: identificacionFileIsValid,
        isTouched: identificacionFileIsTouched,
        divInput: divIdentificacionFile,
        messageFile: messageIdentificacion,
        valueChangeHandler: identificacionFileChangeHanlder,
        inputBlurHandler: identificacionFileBlurHandler,
        scrollToDiv: scrollToDivIdentificacionFile
    } = useFileInput(nombreIdentificacionFile, "application/pdf,image/jpeg");

    useEffect(() => {
        setNombreIdentificacionFile(!!datosPersonales.identificacion ? datosPersonales.identificacion : nombreIdentificacionFile);
    }, [datosPersonales.identificacion, nombreIdentificacionFile, setNombreIdentificacionFile]);

    //INPUT CURRICULUM (ARCHIVO)
    const [nombreCVFile, setNombreCVFile] = useState("");
    const {
        value: curriculumFile,
        fileName: curriculumFileName,
        isValid: curriculumFileIsValid,
        isTouched: curriculumFileIsTouched,
        divInput: divCurriculum,
        messageFile: messageCurriculum,
        valueChangeHandler: curriculumFileChangeHanlder,
        inputBlurHandler: curriculumFileBlurHandler,
        scrollToDiv: scrollToDivCurriculum
    } = useFileInput(nombreCVFile, "application/pdf");

    useEffect(() => {
        setNombreCVFile(!!datosPersonales.curriculum ? datosPersonales.curriculum : nombreCVFile);
    }, [datosPersonales.curriculum, nombreCVFile, setNombreCVFile]);

    //INPUT CARTA DE RECOMENDACION (ARCHIVO)
    const [nombreRecomendacionFile, setRecomendacionFile] = useState("");
    const {
        value: recomendacionFile,
        fileName: recomendacionFileName,
        isValid: recomendacionFileIsValid,
        isTouched: recomendacionFileIsTouched,
        divInput: divRecomendacion,
        messageFile: messageRecomendacion,
        valueChangeHandler: recomendacionFileChangeHanlder,
        inputBlurHandler: recomendacionFileBlurHandler,
        scrollToDiv: scrollToDivRecomendacion
    } = useFileInput(nombreRecomendacionFile, "application/pdf");

    useEffect(() => {
        setRecomendacionFile(!!datosPersonales.recomendacion ? datosPersonales.recomendacion : nombreRecomendacionFile);
    }, [datosPersonales.recomendacion, nombreRecomendacionFile, setRecomendacionFile]);

    //INPUT MOTIVACION (ARCHIVO)
    const [nombreMotivacionFile, setMotivacionFile] = useState("");
    const {
        value: motivacionFile,
        fileName: motivacionFileName,
        isValid: motivacionFileIsValid,
        isTouched: motivacionFileIsTouched,
        divInput: divMotivacion,
        messageFile: messageMotivacion,
        valueChangeHandler: motivacionFileChangeHanlder,
        inputBlurHandler: motivacionFileBlurHandler,
        scrollToDiv: scrollToDivMotivacion
    } = useFileInput(nombreMotivacionFile, "application/pdf");

    useEffect(() => {
        setMotivacionFile(!!datosPersonales.motivacion ? datosPersonales.motivacion : nombreMotivacionFile);
    }, [datosPersonales.motivacion, nombreMotivacionFile, setMotivacionFile]);

    //INPUT EGRESADO
    const egresadoValidacion = value => value === "Y" || value === "N";
    const {
        value: egresado,
        isValid: egresadoIsValid,
        isTouched: egresadoIsTouched,
        userChange: egresadoUserChange,
        divInput: divEgresado,
        valueChangeHandler: egresadoChangeHanlder,
        inputBlurHandler: egresadoBlurHandler,
        scrollToDiv: scrollToDivEgresado,
        setInputValue: setEgresadoValue
    } = useInput(egresadoValidacion);

    useEffect(() => {
        if(!!datosPersonales.es_exal_ufm && !egresadoUserChange){
            setEgresadoValue(datosPersonales.es_exal_ufm);
        }
    }, [datosPersonales.es_exal_ufm, egresadoUserChange, setEgresadoValue]);

    //INPUT CARNE
    const carneValidacion = value => value.trim() !== "" && value.length === 8;
    const {
        value: carne,
        isValid: carneIsValid,
        isTouched: carneIsTouched,
        userChange: carneUserChange,
        divInput: divCarne,
        valueChangeHandler: carneChangeHanlder,
        inputBlurHandler: carneBlurHandler,
        scrollToDiv: scrollToDivCarne,
        setInputValue: setCarneValue,
        resetInput: resetInputCarne
    } = useInput(carneValidacion);

    useEffect(() => {
        if(!!datosPersonales.carne && !carneUserChange){
            setCarneValue(datosPersonales.carne);
        }
    }, [datosPersonales.carne, carneUserChange, setCarneValue]);

    //INPUT IDIOMAS
    const [idiomas, setIdiomas] = useState([]);
    let isIdiomasTouched = false;

    const idiomasDB = useGetIdioma();

    const handleChangeIdiomas = (event) => {
        isIdiomasTouched = true;
        const { checked, value } = event.target;
        
        if( checked && !idiomas.includes(value) ){
            setIdiomas( prevIdiomas => [...prevIdiomas, parseInt(value)] );
        }

        if( !checked && idiomas.includes(parseInt(value)) ){
            setIdiomas(
                prevIdiomas => prevIdiomas.filter( idioma => parseInt(idioma) !== parseInt(value) )
            );
        }

    }

    useEffect(() => {
        // idiomas inicialmente solo tiene valores de la DB 
        if(datosPersonales !== undefined && "arr_idioma" in datosPersonales && !isIdiomasTouched){
            setIdiomas(datosPersonales.arr_idioma);
        }
    },[datosPersonales, isIdiomasTouched]);

    //INPUT OTRO IDIOMA
    const otroIdiomaValidacion = value => value.trim() !== "";
    const {
        value: otroIdioma,
        isValid: otroIdiomaIsValid,
        isTouched: otroIdiomaIsTouched,
        userChange: otroIdiomaUserChange,
        divInput: divOtroIdioma,
        setInputValue: setOtroIdiomaValue,
        valueChangeHandler: otroIdiomaChangeHanlder,
        inputBlurHandler: otroIdiomaBlurHandler,
        scrollToDiv: scrollToDivOtroIdioma,
        resetInput: resetInputOtroIdioma
    } = useInput(otroIdiomaValidacion);

    useEffect(() => {
        if(!!datosPersonales.otro_idioma && !otroIdiomaUserChange){ 
            setOtroIdiomaValue(datosPersonales.otro_idioma);
        }
    }, [datosPersonales.otro_idioma, otroIdiomaUserChange, setOtroIdiomaValue]);

    useEffect(() => {
        let flag = !!datosPersonales.fecha_nacimiento && datosPersonales.fecha_nacimiento !== ""
        if(flag){
            setBlock(true);
            setIsUpdate(true);
        }
    }, [datosPersonales]);
    
    let formIsValid = false;

    if (
        primerNombreIsValid &&
        primerApellidoIsValid &&
        segundoApellidoIsValid &&
        segundoNombreIsValid &&
        apellidoCasadaIsValid &&
       // fechaNaciemientoIsValid &&
       fechaNaciemientoIsValid2 &&
        nacionalidadIsValid &&
        generoIsValid &&
        estadoCivilIsValid &&
        dpiIsValid &&
        numeroIdIsValid && //
        tipoDocumentoIsValid &&
        identificacionFileIsValid &&
        curriculumFileIsValid &&
        recomendacionFileIsValid &&
        motivacionFileIsValid &&
        egresadoIsValid && 
        carneIsValid &&
        otroIdiomaIsValid
    ){
        formIsValid = true;
    }

    const handleSubmit = async (ev) => {
        ev.preventDefault();

        primerNombreBlurHandler();
        segundoNombreBlurHandler();
        primerApellidoBlurHandler();
        segundoApellidoBlurHandler();
        apellidoCasadaBlurHandler();
       // fechaNaciemientoBlurHandler();
        fechaNaciemientoBlurHandler2(); 
        nacionalidadBlurHandler();
        generoBlurHandler();
        estadoCivilBlurHandler();
        tipoDocumentoBlurHandler();
        dpiBlurHandler();
        numeroIdBlurHandler(); //Añadiendo
        identificacionFileBlurHandler();
        curriculumFileBlurHandler();
        recomendacionFileBlurHandler();
        motivacionFileBlurHandler();
        egresadoBlurHandler();
        carneBlurHandler();
        otroIdiomaBlurHandler();

        if(!formIsValid) {

            if(!primerNombreIsValid) {
                scrollToDivPrimerNombre();
                return;    
            }

            if(!primerApellidoIsValid) {
                scrollToDivPrimerApellido();
                return;    
            }

            if(!segundoApellidoIsValid) {
                scrollToDivSegundoApellido();
                return;    
            }

            
            if(!segundoNombreIsValid) {
                scrollToDivSegundoNombre();
                return;    
            }

            if(genero === 'F' && estadoCivil === '2' && !apellidoCasadaIsValid) {
                scrollToDivApellidoCasada();
                return;
            }

           /* if(!fechaNaciemientoIsValid){
                scrollToDivFechaNaciemiento();
                return;
            }*/
              /* Añadiendo el 2*/
              if(!fechaNaciemientoIsValid2){
                scrollToDivFechaNaciemiento2();
                return;
            }

            if(!nacionalidadIsValid) {
                scrollToDivNacionalidad();
                return;
            }

            if(!generoIsValid) {
                scrollToDivGenero();
                return;
            }

            if(!estadoCivilIsValid) {
                scrollToDivEstadoCivil();
                return;
            }

            if(!tipoDocumentoIsValid) {
                scrollToDivTipoDocumento();
                return;
            }

            if(tipoDocumento === "8" && !dpiIsValid && nacionalidad === '1'){
                scrollToDivDpi();
                return;
            }
             
            if(tipoDocumento !== "8"  &&  !numeroIdIsValid){
                scrollToDivNumeroId();
                return;

            }

            if(!identificacionFileIsValid){
                scrollToDivIdentificacionFile();
                return;
            }

            if(!curriculumFileIsValid){
                scrollToDivCurriculum();
                return;
            }

            if(!recomendacionFileIsValid){
                scrollToDivRecomendacion();
                return;
            }

            if(!motivacionFileIsValid){
                scrollToDivMotivacion();
                return;
            }

            if(!egresadoIsValid) {
                scrollToDivEgresado();
                return;
            }

            if(egresado === "Y" && !carneIsValid){
                scrollToDivCarne();
                return;
            }

            if(idiomas.includes(9) && !otroIdiomaIsValid){
                scrollToDivOtroIdioma();
                return;
            }

            if(egresado ==="N"){
                resetInputCarne();
            }

            if(!idiomas.includes(9)){
                resetInputOtroIdioma();
            }
        }

        var event_date = new Date(fechaNaciemiento2);
        let dateprueba = JSON.stringify(event_date)
        dateprueba = dateprueba.slice(1,11)

        const form_data = new FormData();
        form_data.append('idToken', authContext.token);
        form_data.append('primerNombre', primerNombre);
        form_data.append('segundoNombre', segundoNombre);
        form_data.append('primerApellido', primerApellido);
        form_data.append('segundoApellido', segundoApellido);
        form_data.append('apellidoCasada', apellidoCasada);
        form_data.append('fechaNaciemiento', dateprueba);
        form_data.append('nacionalidad', nacionalidad);
        form_data.append('genero', genero);
        form_data.append('estadoCivil', estadoCivil);
        form_data.append('tipoDocumento', tipoDocumento);
        form_data.append('dpi', tipoDocumento === '8' && nacionalidad === '1' ? dpi :  numeroId);

       

        //Mandar otro valor con lo del documento.
        form_data.append('identificacionFile', identificacionFile[0] === undefined ? nombreIdentificacionFile : identificacionFile[0]);
        form_data.append('curriculum', curriculumFile[0] === undefined ? nombreCVFile : curriculumFile[0]);
        form_data.append('recomendacion', recomendacionFile[0] === undefined ? nombreRecomendacionFile : recomendacionFile[0]);
        form_data.append('motivacion', motivacionFile[0] === undefined ? nombreMotivacionFile : motivacionFile[0]);
        form_data.append('egresado', egresado);
        form_data.append('carne', egresado === "Y" ? carne : '');
        form_data.append('idiomas', idiomas);
        form_data.append('otroIdioma', otroIdioma);

        if(isUpdate)
        {
            form_data.append('updateDatosPersonales', 1);
        } else {
            form_data.append('saveDatosPersonales', 1);
        }
        axios.post(process.env.REACT_APP_API_URL, form_data)
        .then(res => {
                setAppValues(
                    prev => {
                        let perfil = prev.datosPersonales ? prev.perfil : prev.perfil+25;
                        return { ...prev, datosPersonales: true, perfil };
                    }
                );
                setIsUpdate(true);
                handleEditar();
                props.onCompletado('datos-personales');
            })
            .catch((error) => {
                console.log(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un problema, intentelo más tarde',
                    showConfirmButton: false,
                    timer: 3500
                });

            })
    }

    return (
        <>
        {
            error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body d-flex align-items-center justify-content-center" style={{ height: '565px' }}>
                            <div className="text-center" style={{ color: 'rgba(0,0,0,.3)', fontSize: '2.5rem' }} >
                                <span style={{ fontSize: "7rem" }}><MdErrorOutline/></span>
                                <br />
                                ¡Error!
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        }
        { !error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body">
                            <form className="row my-4" onSubmit={ev => handleSubmit(ev)}>

                                {/* NOMBRE */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divPrimerNombre}>
                                    <label className="form-label text-black-50" ref={divSegundoNombre}>Nombre(s)</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            name="primerNombre"
                                            placeholder="Primer nombre"
                                            value={primerNombre}
                                            className={`form-control form-control-sm shadow-sm ${primerNombreIsTouched ? ((primerNombreIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            onChange={primerNombreChangeHanlder}
                                            onBlur={primerNombreBlurHandler}
                                            autoComplete='off'
                                            readOnly={block ? true : false}
                                            disabled={block ? true : false} />
                                         <input
                                            type="text"
                                            name="segundoNombre"
                                            placeholder="Segundo nombre"
                                            value={segundoNombre}
                                            className={`form-control form-control-sm shadow-sm ${segundoNombreIsTouched ? ((segundoNombreIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            onChange={segundoNombreChangeHanlder}
                                            onBlur={segundoNombreBlurHandler}
                                            autoComplete='off'
                                            readOnly={block ? true : false}
                                            disabled={block ? true : false} />
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Campo obligatorio
                                        </div>
                                    </div>
                                </div>

                                {/* APELLIDO(S) */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divPrimerApellido}>
                                    <label className="form-label text-black-50" ref={divSegundoApellido}>Apellido(s)</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            name="primerApellido"
                                            placeholder="Primer Apellido"
                                            value={primerApellido}
                                            className={`form-control form-control-sm shadow-sm ${primerApellidoIsTouched ? ((primerApellidoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            onChange={primerApellidoChangeHanlder}
                                            onBlur={primerApellidoBlurHandler}
                                            autoComplete='off'
                                            readOnly={block ? true : false}
                                            disabled={block ? true : false} />
                                        <input
                                            type="text"
                                            name="segundoApellido"
                                            placeholder="Segundo Apellido"
                                            value={segundoApellido}
                                            className={`form-control form-control-sm shadow-sm ${segundoApellidoIsTouched ? ((segundoApellidoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            onChange={segundoApellidoChangeHanlder}
                                            onBlur={segundoApellidoBlurHandler}
                                            autoComplete='off'
                                            readOnly={block ? true : false}
                                            disabled={block ? true : false} />
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Campo obligatorio
                                        </div>
                                    </div>
                                </div>

                                {/* APELLIDO CASADA */}
                                <div className={`col-md-10 offset-md-1 mb-3 ${genero === "F" && estadoCivil === '2' ? '' : 'd-none'}`} ref={divApellidoCasada}>
                                    <label className="form-label text-black-50">Apellido de casada</label>
                                    <input
                                        type="text"
                                        name="apellidoCasada"
                                        placeholder="Apellido de casada"
                                        value={apellidoCasada}
                                        className={`form-control form-control-sm shadow-sm ${apellidoCasadaIsTouched ? ((apellidoCasadaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={apellidoCasadaChangeHanlder}
                                        onBlur={apellidoCasadaBlurHandler}
                                        autoComplete='off'
                                        readOnly={block ? true : false}
                                        disabled={block ? true : false} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                <hr className="col-md-10 offset-md-1 my-4 text-black-50 shadow-sm" />

                                {/* FECHA DE NACIMIENTO */}
                                <div className="col-md-6 offset-md-1 mb-3" ref={divFechaNaciemiento2}>



<label className="form-label text-black-50">Fecha de nacimiento</label>


<DatePicker
selected= {fechaNaciemiento2 === null ? null :  moment(fechaNaciemiento2).toDate()} //Devuelve 1 día de más
name="fechaNaciemiento2"
onChange={fechaNaciemientoChangeHanlder2}
placeholderText={'dd / mm / yyyy'} 
className={`form-control form-control-sm shadow-sm ${fechaNaciemientoIsTouched2 ? ((fechaNaciemientoIsValid2) ? 'is-valid' : 'is-invalid') : ''}`}
dateFormat = "dd / MM / yyyy"
minDate={new Date(date[0]-100, 0, 1)}
maxDate={new Date(date[0]-18, date[1]-1,date[2])}
onChangeRaw={(e) => e.preventDefault()}
onBlur={fechaNaciemientoBlurHandler2}
readOnly={block ? true : false}
disabled={block ? true : false} 
//isClearable
yearDropdownItemNumber={15} //Puede servir esto.
showYearDropdown
scrollableYearDropdown
/>


<div className="invalid-feedback d-block" style={{userSelect: 'none'}}>
{fechaNaciemientoIsTouched2  ? ((fechaNaciemientoIsValid2) ? '' : 'Campo Obligatorio'): ''} 
    </div>

    

</div>

                                {/* SEXO */}
                                <div className="col-md-5 offset-md-1 mb-3" ref={divGenero}>
                                    <label className="form-label text-black-50">Sexo</label>
                                    <select
                                        name="genero"
                                        value={genero}
                                        className={`form-select form-select-sm shadow-sm ${generoIsTouched ? ((generoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={generoChangeHanlder}
                                        onBlur={generoBlurHandler}
                                        disabled={block ? true : false} >
                                        <option value="" defaultValue={'DEFAULT'} default={true} hidden={true}>Seleccionar</option>
                                        <option value="M">Masculino</option>
                                        <option value="F">Femenino</option>
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                <div className="col-md-6">&nbsp;</div>

                                {/* ESTADO CIVIL */}
                                <div className="col-md-5 offset-md-1 mb-3" ref={divEstadoCivil}>
                                    <label className="form-label text-black-50">Estado civil</label>
                                    <select
                                        name="estadoCivil"
                                        value={estadoCivil}
                                        className={`form-select form-select-sm shadow-sm ${estadoCivilIsTouched ? ((estadoCivilIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={estadoCivilChangeHanlder}
                                        onBlur={estadoCivilBlurHandler}
                                        disabled={block ? true : false} >
                                        <option value="" defaultValue={'DEFAULT'} default={true} hidden={true}>Seleccionar</option>
                                        {estados.map(estado => (
                                            <option key={estado.estado_civil} value={estado.estado_civil}>{estado.nombre}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                <div className="col-md-3">&nbsp;</div>

                                {/* PAIS DE NACIMIENTO */}
                                <div className="col-md-8 offset-md-1 mb-3" ref={divNacionalidad}>
                                    <label className="form-label text-black-50">País de nacimiento</label>
                                    <select
                                        name="nacionalidad"
                                        value={nacionalidad}
                                        className={`form-select form-select-sm shadow-sm ${nacionalidadIsTouched ? ((nacionalidadIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={nacionalidadChangeHanlder}
                                        onBlur={nacionalidadBlurHandler}
                                        disabled={block ? true : false} >
                                        <option value="" defaultValue={'DEFAULT'} default={true} hidden={true}>Seleccionar</option>
                                        {nacionalidades.map(nacionalidad => (
                                            <option key={nacionalidad.PAIS} value={nacionalidad.PAIS}>{nacionalidad.NOMBRE}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* DOCUMENTO DE IDENTIFICACION */}
                                <div className="col-md-10 offset-md-1 mb-1" ref={divTipoDocumento}>
                                    <label className="form-label text-black-50">Documento de identificación</label>
                                    <div className="input-group shadow-sm">
                                        <select
                                            name="tipoDocumento"
                                            value={tipoDocumento}
                                            className={`form-select form-select-sm shadow-sm ${tipoDocumentoIsTouched ? ((tipoDocumentoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            onChange={tipoDocumentoChangeHanlder}
                                            onBlur={tipoDocumentoBlurHandler}
                                            disabled={block ? true : false} >
                                            <option value="" defaultValue={'DEFAULT'} default={true} hidden={true}>Seleccionar</option>
                                            {tipo_identifiacacion.map(tipo => (
                                                <option key={tipo.tipo_identificacion} value={tipo.tipo_identificacion}>{tipo.nombre}</option>
                                            ))}
                                        </select>
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Campo obligatorio
                                        </div>
                                    </div>
                                </div>
                                

                                {/*Esta debe ser una validación condicional */}
                                <div className={`col-md-10 offset-md-1 mb-3 ${tipoDocumento === '8'  && nacionalidad === '1' ? '' : 'd-none'}`} ref={divDpi}>
                                    <input
                                        type="text"
                                        name="dpi"
                                        placeholder="Número de identificación"
                                        value={dpi}
                                        className={`form-control form-control-sm shadow-sm ${dpiIsTouched ? ((dpiIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={dpiChangeHanlder}
                                        onBlur={dpiBlurHandler}
                                        autoComplete='off'
                                        readOnly={block ? true : false}
                                        disabled={block ? true : false} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        {dpi === '' ? 'Campo obligatorio' : 'DPI inválido'}
                                    </div>
                                </div>


                                <div className={`col-md-10 offset-md-1 mb-3 ${tipoDocumento === '8'  && nacionalidad === '1' ? 'd-none' : ''}`} ref={divNumeroId}>
                                    <input
                                        type="text"
                                        name="numeroId"
                                        placeholder="Número de identificación"
                                        value={numeroId}
                                        className={`form-control form-control-sm shadow-sm ${numeroIdIsTouched ? ((numeroIdIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={numeroIdChangeHanlder}
                                        onBlur={numeroIdBlurHandler}
                                        autoComplete='off'
                                        readOnly={block ? true : false}
                                        disabled={block ? true : false} />
                    
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Campo obligatorio
                                        </div>
                                </div>

                                <div className="col-md-10 offset-md-1 mb-3" ref={divIdentificacionFile}>
                                    <input
                                        type="file"
                                        name="identificacionFile"
                                        className={`form-control form-control-sm shadow-sm ${identificacionFileIsTouched ? ((identificacionFileIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={identificacionFileChangeHanlder}
                                        onBlur={identificacionFileBlurHandler} 
                                        placeholder="sadf"
                                        disabled={block ? true : false} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        {messageIdentificacion}
                                    </div>
                                    {identificacionFileIsValid && <div id="identificacionFileHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {identificacionFileName}
                                    </div>}
                                </div>

                                <hr className="col-md-10 offset-md-1 my-4 text-black-50 shadow" />

                                {/* ARCHIVO CV */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divCurriculum}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Adjuntar CV (PDF)</label>
                                    <input
                                        type="file"
                                        name="curriculum"
                                        className={`form-control form-control-sm shadow-sm ${curriculumFileIsTouched ? ((curriculumFileIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={curriculumFileChangeHanlder}
                                        onBlur={curriculumFileBlurHandler} 
                                        disabled={block ? true : false} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        {messageCurriculum}
                                    </div>
                                    {curriculumFileIsValid && <div id="curriculumHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {curriculumFileName}
                                    </div>}
                                </div>

                                {/* ARCHIVO RECOMENDACION */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divRecomendacion}>
                                    <label className="form-label text-black-50">Adjuntar carta de recomendación (PDF)</label>
                                    <input
                                        type="file"
                                        name="recomendacion"
                                        className={`form-control form-control-sm shadow-sm ${recomendacionFileIsTouched ? ((recomendacionFileIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={recomendacionFileChangeHanlder}
                                        onBlur={recomendacionFileBlurHandler} 
                                        disabled={block ? true : false} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        {messageRecomendacion}
                                    </div>
                                    {recomendacionFileIsValid && <div id="recomendacionHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {recomendacionFileName}
                                    </div>}
                                </div>

                                {/* ARCHIVO MOTIVACION */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divMotivacion}>
                                    <label className="form-label text-black-50">Adjuntar carta de motivación (PDF)</label>
                                    <input
                                        type="file"
                                        name="motivacion"
                                        className={`form-control form-control-sm shadow-sm ${motivacionFileIsTouched ? ((motivacionFileIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={motivacionFileChangeHanlder}
                                        onBlur={motivacionFileBlurHandler} 
                                        disabled={block ? true : false}
                                    />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        {messageMotivacion}
                                    </div>
                                    {motivacionFileIsValid && <div id="motivacionHelp" className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {motivacionFileName}
                                    </div>}
                                </div>

                                {/* IDIOMAS */}
                                <div className="col-md-10 offset-md-1 mb-3">
                                    <label className="form-label text-black-50 mb-1">Idiomas: </label>
                                    {Array.isArray(idiomasDB) && idiomasDB.map(
                                        idioma => {
                                            const checked = idiomas.includes(parseInt(idioma.value));

                                            return (
                                                <div className="form-check" key={idioma.name}>
                                                    <input 
                                                        type="checkbox" 
                                                        className='form-check-input'
                                                        name={"idioma_"+parseInt(idioma.value)}
                                                        value={parseInt(idioma.value)}
                                                        onChange={handleChangeIdiomas}
                                                        checked={checked}
                                                        disabled={block ? true : false} />
                                                    <label className='form-check-label'>{idioma.name}</label>
                                                </div>
                                            )
                                        }
                                    )}

                                    {/* OTRO IDIOMA */}
                                    <input ref={divOtroIdioma}
                                        type="text"
                                        name="otroIdioma"
                                        value={otroIdioma}
                                        className={`form-control form-control-sm shadow-sm ${idiomas.includes(9) ? '' : 'd-none'} ${otroIdiomaIsTouched ? ((otroIdiomaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        onChange={otroIdiomaChangeHanlder}
                                        onBlur={otroIdiomaBlurHandler}
                                        readOnly={block ? true : false}
                                        disabled={block ? true : false}
                                        placeholder={"Escriba otro(s) idioma(s)"} />
                                    <div className={`${idiomas.includes(9) ? 'invalid-feedback' : 'd-none'}`} style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* EGRESADO UFM */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divEgresado}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>¿Es egresado de UFM?</label>
                                    <div className="form-check">
                                        <input 
                                            type="radio"
                                            className={`form-check-input shadow-sm ${egresadoIsTouched ? ((egresadoIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="experiencia"
                                            value="Y"
                                            checked={egresado === "Y"}
                                            onChange={egresadoChangeHanlder}
                                            onBlur={egresadoBlurHandler} 
                                            disabled={block ? true : false} />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>Sí</label>
                                    </div>
                                    <div className="form-check" ref={divCarne}>
                                        <input 
                                            type="radio"
                                            className={`form-check-input shadow-sm ${egresadoIsTouched ? ((egresadoIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="experiencia"
                                            value="N"
                                            checked={egresado === "N"}
                                            onChange={egresadoChangeHanlder}
                                            onBlur={egresadoBlurHandler} 
                                            disabled={block ? true : false} />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>No</label>
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Debe seleccionar una opción
                                        </div>
                                    </div>
                                    <input
                                        type="text"
                                        name="carne"
                                        placeholder='Ingresar carnet UFM'
                                        value={carne}
                                        className={`form-control form-control-sm shadow-sm ${egresado === 'Y'? (carneIsTouched ? ((carneIsValid) ? 'is-valid' : 'is-invalid') : ''): 'd-none'}`}
                                        onChange={carneChangeHanlder}
                                        onBlur={carneBlurHandler}
                                        autoComplete="off"
                                        readOnly={block ? true : false} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Debe ingresar un numero de carné válido
                                    </div>
                                </div>

                                {/* EDITAR/GUARDAR */}
                                <div className="col-md-10 offset-md-1 mt-3" style={{ textAlign: 'right' }}>
                                    <div className="btn-group">
                                        <button 
                                            className={`btn ${block ? 'btn-dark':'btn-outline-dark disabled'}`}
                                            type="button"
                                            onClick={() => handleEditar()}
                                            disabled={!block} >
                                            <MdEdit /> Editar
                                        </button>
                                        <button 
                                            className={`btn ${block ? 'btn-outline-danger disabled':'btn-danger'}`}
                                            disabled={block} 
                                            type="submit">
                                            <MdSave /> Guardar
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </ Card>
                </div>
            </div>
        }
        </>
    );
};

export default DatosPersonales;